
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobiworkx/redeem",
      function () {
        return require("private-next-pages/mobiworkx/redeem/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobiworkx/redeem"])
      });
    }
  